export default "__VITE_ASSET__a8c4b765__"